"use strict";import m from"./src/scale-medium.css.js";import{Theme as e}from"./src/Theme.js";import"./core.js";e.registerThemeFragment("medium","scale",m);
//# sourceMappingURL=scale-medium.js.map
